/**
* @Description 文件功能说明：应用明细
* @Author
* @Time 
**/

/* HTML */
<template>
    <div class="form-model-view">
        <div class="title-item-box">
            <span>新增区域</span>
            <el-button class="title-item-btn" icon="el-icon-save" style="float: right;" @click="cancel">取消</el-button>
            <el-button class="title-item-btn" icon="el-icon-save" style="float: right;" @click="save">保存</el-button>
        </div>
        <div class="form-unit-box">
            <el-form :model="rowForm" ref="rowForm" :rules="rules" label-width="130px">
                <el-form-item label="项目名称：">
                    {{nodeData.name}}
                </el-form-item>
                <el-form-item label="区域名称：" prop="name">
                    <el-input v-model="rowForm.name"/>
                </el-form-item>
                <el-form-item :label="autoMapFlag ? '是否生成地图：' : '是否上传地图：'" prop="hasMap">
                    <el-radio-group v-model="rowForm.hasMap" @change="changeHandle">
                        <el-radio class="radio" :label="1" >是</el-radio>
                        <el-radio class="radio" :label="0" >否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-show="rowForm.hasMap==1">
                    <template>
                    	<!-- 自动生成地图 start -->
	                    <el-form-item class="vertical-form-item p-t-5 p-l-20 content-pt-35" prop="mapFile" v-if="autoMapFlag" style="margin-bottom: 20px;">
							<span slot="label">
								<span style="padding-right: 0px;"><font color="#F56C6C">*</font>生成地图<i style="padding-left: 0px;">：填写实际测量数据之后点击 生成地图 按钮，自动生成地图 </i></span>
							</span>
							
							<el-form-item class="vertical-form-item m-b-0 float-left p-r-10" label="测量距离横向, 纵向：" prop="realWidth" style="width: calc((100% - 90px) / 2)">
	                            <el-input v-model="rowForm.realWidth">
	                                <template slot="append">米</template>
	                            </el-input>
	                        </el-form-item>
	                        <el-form-item class="vertical-form-item m-b-0 float-left p-r-10" prop="realHeight" style="width: calc((100% - 90px) / 2)">
	                            <el-input v-model="rowForm.realHeight">
	                                <template slot="append">米</template>
	                            </el-input>
	                        </el-form-item>
							<el-form-item class="vertical-form-item m-b-0 float-left p-r-10" style="width: 90px;">
	                            <el-button type="primary" @click.native="creatFile" size="small" style="height: 46px;">生成地图</el-button>
	                        </el-form-item>
	                    </el-form-item>
	                    <!-- 自动生成地图 end -->
                    	
                    	<el-form-item v-else label="上传地图：" prop="mapFile">
	                        <el-upload
	                            style="display: inline-block;"
	                            ref="uploadImg"
	                            accept="image/jpeg,image/jpg,image/png"
	                            :auto-upload="false"
	                            :show-file-list="false"
	                            :before-upload="beforeUpload"
	                            :on-success="uploadSuccess"
	                            :on-error="uploadError"
	                            :action="upload.uploadUrl"
	                            :headers="upload.myHeaders"
	                            :on-change="(file,fileList)=>{return changeFile(file,fileList)}"
	                        ><el-button type="primary" size="mini">上传地图</el-button></el-upload>
	                    </el-form-item>
                    </template>
                    
                    <el-form-item class="row-items-1" label-width="0px" v-show="!emptyMapUrl">
                        <div style="width: 100%;overflow: hidden;">
                            <div class="raphae-map-box h-m-400">
                                <SubRaphaelMap ref="svgMap" :mapEleId="'addAreaId'"/>
                            </div>
                        </div>
                    </el-form-item>
                    <template v-if="!autoMapFlag">
                    	<el-form-item label="X起点(米)：" prop="startPointX">
	                        <el-input v-model="rowForm.startPointX"/>
	                    </el-form-item>
	                    <el-form-item label="Y起点(米)：" prop="startPointY">
	                        <el-input v-model="rowForm.startPointY"/>
	                    </el-form-item>
	                    <el-form-item label="Z起点(米)：" prop="startPointZ">
	                        <el-input v-model="rowForm.startPointZ"/>
	                    </el-form-item>
	                    <el-form-item label="X像素(Px)：" prop="startPointXPx">
	                        <el-input v-model="rowForm.startPointXPx"/>
	                    </el-form-item>
	                    <el-form-item label="Y像素(Px)：" prop="startPointYPx">
	                        <el-input v-model="rowForm.startPointYPx"/>
	                    </el-form-item>
	                    <el-form-item label="X比例(Px/米)：" prop="scaleX">
	                        <el-input v-model="rowForm.scaleX"/>
	                    </el-form-item>
	                    <el-form-item label="Y比例(Px/米)：" prop="scaleY">
	                        <el-input v-model="rowForm.scaleY"/>
	                    </el-form-item>
                    </template>
                </div>
            </el-form>
        </div>
    </div>
</template>

/* JS */
<script>
    import ApiOam from '@/request/api-oam'
    import GlobalFun from '@/global/global-function'
    import SubRaphaelMap from '@/components/SubRaphaelMap'
    // 地图 img
	import defaultImg from '@/static_dazzle/images/template/grid-20px-500x500.png';
    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 
         */
        name: 'AreaAdd',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 
         */
        props: {
            // 节点信息
            nodeData: Object
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 
         */
        components: {
            // svg地图
            SubRaphaelMap,
        },
        mounted(){
            // 重新加载数据
            this.$nextTick(() => {
                //this.searchRow();
                
				// 地图数据 初始化
                this.initMapData();
            })
        },
        /**
         * @Des 销毁
         * @Auth
         * @Date
         */
        destroyed() {
            // 销毁 svg地图
            this.$refs.svgMap && this.$refs.svgMap.destroySvg();
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 
         */
        data() {
            return{
                // 交互锁
                operationLock: false,
                // 地图为空
                emptyMapUrl: true,
                rowForm: {
                    name: '',
                    hasMap: 0,
                    // 地图 img addr
                    mapAddr: '',
                    // 选取 地图
                    mapFile: '',
                    realWidth: '',
                    realHeight: '',
                    mapUrl: '',
                    offsetX: 0,
                    offsetY: 0,
                    offsetZ: 0,
                    startPointX: 0,
                    startPointY: 0,
                    startPointZ: 0,
                    startPointXPx: '',
                    startPointYPx: '',
                    scaleX: '',
                    scaleY: '',
                },
                /**
                 * @Des 地图信息
                 * @Auth
                 * @Date
                 */
                mapOption: {},
                // 地图模块
                mapSub: null,
                
                // flag 自动生成地图
				autoMapFlag: false,
				// flag 点击按钮
				handleAutoFlag: false,
                
                /**
                 * @Des 文件上传 change
                 * @Auth
                 * @Date 
                 */
                upload:{
                    myHeaders: {
                        token: this.$store.state.token,
                        lang: this.$store.state.lang,
                        loginDevice: this.$store.state.loginDevice
                    },
                    uploadUrl: ApiOam.Upload_Map_Uri,
                },
                rules:{
                    name: [
                        { required: true, message: '名称不能为空', trigger: 'blur' }
                    ],
                    mapUrl: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('地图地址不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    mapFile: [
                    	{
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1) {
                                    if (this.$checkEmpty(value) && this.$checkEmpty(this.rowForm.mapUrl)) {
                                        if (this.autoMapFlag) {
                                    		new callback(new Error('请生成地图'))
                                    	} else {
                                    		new callback(new Error('请选择地图'))
                                    	}
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    realWidth: [
                        {
                            validator: (rule, value, callback) => {
                                if(!this.handleAutoFlag){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('横向测量距离不能为空'))
                                    } else if (!(parseFloat(value) > 0)) {
                                    	new callback(new Error('横向测量距离应为大于0的数字'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],// realWidth
                    realHeight: [
                        {
                            validator: (rule, value, callback) => {
                                if(!this.handleAutoFlag){
                                    callback()
                                }else{
                                    if (this.$checkEmpty(value)) {
                                        new callback(new Error('纵向测量距离不能为空'))
                                    } else if (!(parseFloat(value) > 0)) {
                                    	new callback(new Error('纵向测量距离应为大于0的数字'))
                                    } else {
                                        callback()
                                    }
                                }
                            },
                            trigger: "blur"
                        }
                    ],// realHeight
                    startPointX: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('X起点不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointY: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('Y起点不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointZ: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('Z起点不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointXPx: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('X像素不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    startPointYPx: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('Y像素不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleX: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('X比例不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    scaleY: [
                        {
                            validator: (rule, value, callback) => {
                                if(this.rowForm.hasMap == 1){
                                    if(this.$checkEmpty(value)){
                                        new callback(new Error('Y比例不能为空'))
                                    } else {
                                        callback()
                                    }
                                }else{
                                    callback()
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                }
            }
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 
         */
        methods:{
            changeHandle(value){
                this.rowForm.hasMap = value;
                
                // 地图数据 初始化
                this.initMapData();
            },
            /**
	         * @Des 检索是否有地图
	         * @Auth
	         * @Date
	         */
            checkMapUrl() {
                this.emptyMapUrl = this.$checkEmpty(this.rowForm.mapFile) && this.$checkEmpty(this.rowForm.mapUrl);
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 
             */
            beforeUpload(file){
                // 上传之前
                //console.log(file)
                let extension = file.name.substring(file.name.lastIndexOf('.')+1);
                let size = file.size/1024/1024;
                // console.log(extension, size)
                if(['png', 'jpg', 'jpeg'].indexOf(extension) === -1) {
                    this.$message.warning('只能上传后缀是 .png/.jpg/.jpeg 的文件');
                } else if(size > 100) {
                    // this.$message.warning('文件大小不得超过100M');
                }
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 
             */
            uploadSuccess(res, file, fileList) {
                // 上传成功
                //console.log(res, file, fileList);
                if(res.code == 0){
                    // 返回数据
                    // console.log(res.data)

                    let mapAddr = '';
                    if (!this.$checkEmpty(res.data) && !this.$checkEmpty(res.data.path)) {
                        mapAddr = res.data.path;
                    }

                    this.rowForm.mapFile = '';
                    this.rowForm.mapAddr = mapAddr;

                    // 提交数据 交互
                    this.requestSubmit();

                }else{
                    this.$message({
                        type: 'error',
                        message: res.msg ,
                        dangerouslyUseHTMLString: true
                    });
                    // 交互锁
                    this.operationLock = false;
                }
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 
             */
            uploadError(err, file, fileList) {
                // 上传失败
                this.$message({
                    type: 'error',
                    message: err.msg ,
                    dangerouslyUseHTMLString: true
                });
                // 交互锁
                this.operationLock = false;
            },
            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 
             */
            changeFile(file,fileList) {
                // console.log(file)
                
                // 交互锁
                this.operationLock = false;
                
                let _this = this;
                // file 转换成 base64
                GlobalFun.readFileImg(file.raw, data => {
                    this.mapOption.mapUrl = data.src;
                    this.mapOption.mapHeight = data.height;
                    this.mapOption.mapWidth = data.width;
                    this.rowForm.mapFile = data.src;

					// 检索是否有地图
					this.checkMapUrl();
                    // console.log(this.rowForm)

                    // 初始化 svg地图
                    if(!this.mapSub){
                        this.mapSub = this.$refs.svgMap;
                    }
                    this.mapSub.initMap(this.mapOption);
                    // 双击取点
                    this.mapSub.allowDrawDisc(true, (startX, startY) => {
                        // 起始点X
                        this.rowForm.startPointXPx = startX;
                        // 起始点X
                        this.rowForm.startPointYPx = startY;
                    });
                });
            },
            
            /**
			 * @Des 地图数据 初始化
			 * @Auth
			 * @Date
			 */
            initMapData() {
            	// flag 自动生成地图
				this.autoMapFlag = this.nodeData.project.appId == '624b863a82a1e7bed3e066baaddf8a3e8';
            	// 自动生成地图
            	if (this.autoMapFlag) {
            		// 地图数据
            		this.rowForm['startPointXPx'] = this.rowForm.hasMap != 1 ? '' : 0;
            		this.rowForm['startPointYPx'] = this.rowForm.hasMap != 1 ? '' : 0;
            		this.rowForm['scaleX_map'] = this.rowForm.hasMap != 1 ? '' : 20;
            		this.rowForm['scaleY_map'] = this.rowForm.hasMap != 1 ? '' : 20;
            		this.rowForm['scaleX_real'] = this.rowForm.hasMap != 1 ? '' : 2;
            		this.rowForm['scaleY_real'] = this.rowForm.hasMap != 1 ? '' : 2;
            		this.rowForm['scaleX'] = this.rowForm.hasMap != 1 ? '' : [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/');
            		this.rowForm['scaleY'] = this.rowForm.hasMap != 1 ? '' : [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/');
            	}
            },// initMapData
            /**
			 * @Des 生成地图
			 * @Auth
			 * @Date
			 */
            creatFile() {
            	// flag 点击按钮
				this.handleAutoFlag = true;
            	this.$refs.rowForm.clearValidate(['mapFile']);
            	
            	let validFlag = true;
            	this.$refs.rowForm.validateField('realWidth', (err) => {
            		if (err) validFlag = false;
            	});
            	this.$refs.rowForm.validateField('realHeight', (err) => {
            		if (err) validFlag = false;
            	});
            	// flag 点击按钮
				this.handleAutoFlag = false;
            	
            	// 验证未通过 中止
            	if (!validFlag) return false;
            	
            	let scaleXs = [this.rowForm.scaleX_map, this.rowForm.scaleX_real];
            	let scaleYs = [this.rowForm.scaleY_map, this.rowForm.scaleY_real];
            	// 参数 地图
				this.mapOption.mapWidth = Math.ceil((this.rowForm.realWidth * scaleXs[0] / scaleXs[1]) / 20) * 20;
				this.mapOption.mapHeight = Math.ceil((this.rowForm.realHeight * scaleYs[0] / scaleYs[1]) / 20) * 20;
				
				// 比例 地图
				this.mapOption.scaleX = [this.rowForm.scaleX_map, this.rowForm.scaleX_real].join('/');
				this.mapOption.scaleY = [this.rowForm.scaleY_map, this.rowForm.scaleY_real].join('/')
				
				// 裁剪的地图
				this.$SubFn.sliceImg({
					src: defaultImg,
					rect: {
						x: 0, // 截取方格左上角横坐标
						y: 0, // 截取方格左上角纵坐标
						width: this.mapOption.mapWidth, // 截取方格宽度
						height: this.mapOption.mapHeight // 截取方格高度
					}
				}).then(result => {
					
					this.mapOption.mapUrl = result;
                    this.rowForm.mapFile = result;
					
					// 检索是否有地图
					this.checkMapUrl();
                    // console.log(this.rowForm)

                    // 初始化 svg地图
                    if(!this.mapSub){
                        this.mapSub = this.$refs.svgMap;
                    }
                    
                    this.mapSub.initMap(this.mapOption);
                    // 绘制圆点
                    this.mapSub.initDrawDisc([this.rowForm.startPointXPx, this.rowForm.startPointYPx].join(','), 5);
                    // 双击取点
                    /*this.mapSub.allowDrawDisc(true, (startX, startY) => {
                        // 起始点X
                        this.rowForm.startPointXPx = startX;
                        // 起始点X
                        this.rowForm.startPointYPx = startY;

                        // 表单校验
						this.$refs.rowForm.validateField('startPointXPx', error => {});
						this.$refs.rowForm.validateField('startPointYPx', error => {});
                    });*/
                    // 允许 比例图元
                    this.mapSub.allowShowScaleLine(false);
                    
				}).catch(error => {
					this.mapOption.mapUrl = '';
                    this.rowForm.mapFile = '';
                    // 检索是否有地图
					this.checkMapUrl();
				});// this.$SubFn.sliceImg
            },// creatFile
            
            /**
             * 取消
             */
            cancel(){
                // 清空验证
                this.$refs.rowForm.clearValidate();
                
                this.$emit("addNode", false);
                // 交互锁
                this.operationLock = false;
            },
            /**
             * 保存
             */
            save(){
                if (this.operationLock) return false;
                this.$refs.rowForm.validate(valid => {
                    if (!valid) return false;
                    this.operationLock = true;
					
					// 提交数据 交互
					this.requestSubmit();
					
					return false;
                    if (this.rowForm.hasMap == 1 && !this.$checkEmpty(this.rowForm.mapFile)) {
                        // 编辑 && 更改地图

                        // 上传图片
                        this.$refs['uploadImg'].submit();

                    } else {
                        // 提交数据 交互
                        this.requestSubmit();
                    }
                });
            },
            /**
             * @Des 提交交互
             * @Auth
             * @Date
             */
            requestSubmit() {
            	// 区域无地图 => 重置起点和偏移量
            	if (this.rowForm.hasMap != 1) {
            		// 区域无地图
            		
            		this.rowForm.startPointX = 0;
                    this.rowForm.startPointY = 0;
                    this.rowForm.startPointZ = 0;
            	}
            	
            	let mapAddr;
				let mapHeight;
				let mapWidth;
            	if (this.rowForm.hasMap == 1) {
            		mapAddr = !this.$checkEmpty(this.mapOption.mapUrl) ? this.mapOption.mapUrl.split('base64,')[1] : this.rowForm.mapUrl;
            		mapHeight = !this.$checkEmpty(this.mapOption.mapHeight) ? this.mapOption.mapHeight : this.rowForm.height;
            		mapWidth = !this.$checkEmpty(this.mapOption.mapWidth) ? this.mapOption.mapWidth : this.rowForm.width;
            	}
            	
            	this.$request.postJsonRequest(ApiOam.Add_Area_Uri, {
                    projectId: this.nodeData.id,
                    areaName: this.rowForm.name,
                    hasMap: this.rowForm.hasMap,
                    mapAddr: mapAddr,//this.rowForm.mapAddr,
                    height: mapHeight,
                    width: mapWidth,
                    offsetX: 0,
                    offsetY: 0,
                    offsetZ: 0,
                    startPointX: this.rowForm.startPointX,
                    startPointY: this.rowForm.startPointY,
                    startPointZ: this.rowForm.startPointZ,
                    startPointXPx: this.rowForm.startPointXPx,
                    startPointYPx: this.rowForm.startPointYPx,
                    scaleX: this.rowForm.scaleX,
                    scaleY: this.rowForm.scaleY,
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: '保存成功！',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.$emit('setSelectVal', this.nodeData, true);
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.cancel();
                    // 交互锁
                    this.operationLock = false;
                }).catch(error => {
                	// 交互锁
                	this.operationLock = false;
                	console.error('添加区域异常', ApiOam.Add_Area_Uri, error);
                });
            }
        }
    }
</script>

/* CSS */
<style lang="scss" scoped>
	
</style>



// WEBPACK FOOTER //
// src/components_pages/Organization/AreaAdd.vue